import { Component, OnInit } from '@angular/core';
import { ConfidenceMonitoringService } from 'src/app/services/confidence-monitoring.service';
import { AlarmService } from '../services/alarm.service';
import { VideoStreamService } from '../services/video-stream.service';
import { Subscription } from 'rxjs';
import { UserSessionStateService } from '../services/user-session-state.service';
import { Utility } from '../utils/app-utils';

@Component({
  selector: 'app-send-alarm',
  templateUrl: './send-alarm.component.html',
  styleUrls: ['./send-alarm.component.scss']
})
export class SendAlarmComponent implements OnInit {
  displayedColumns = [
    'Sites',
    'Region',
    'Site Priority',
    'Status'
  ];

  public getSitesChangedSub: Subscription;

  constructor(
    public confidenceMonitoringService: ConfidenceMonitoringService,
    public alarmService: AlarmService, public videoStreamService: VideoStreamService,
    public userSessionStateService: UserSessionStateService) { }

  ngOnInit() {
    this.getSitesChangedSub = this.confidenceMonitoringService.getSitesChangedNotification().subscribe(async (branch: any) => {
      this.userSessionStateService.modifyThermalState(false);
      await this.videoStreamService.setEmptyVideoSources();
      await this.videoStreamService.fetchVideoSourcesList(branch.id);
    });
  }

  ngOnDestroy() {
    Utility.Unsubscribe(this.getSitesChangedSub);
  }

}
